import { createContext, PropsWithChildren, useContext } from "react";
import { UseNotificationsResult } from "./hooks/useNotificationsState";

const NotificationsContext = createContext<UseNotificationsResult | null>(null);

type NotificationsProviderProps = PropsWithChildren<{
  value: UseNotificationsResult;
}>;

export const NotificationsProvider = ({
  children,
  value,
}: NotificationsProviderProps) => (
  <NotificationsContext.Provider value={value}>
    {children}
  </NotificationsContext.Provider>
);

// This hook is a convenience wrapper around useContext(NotificationsContext)
// that throws an error if the context is not available.
// This is useful for ensuring that the context is only used within a NotificationsProvider.
export const useNotifications = () => {
  const context = useContext(NotificationsContext);

  if (!context) {
    throw new Error(
      "useNotifications must be used within a NotificationsProvider"
    );
  }

  return context;
};
